'use client';

import { Icon, SimpleCard, Typography } from '@polyseme/design-system';
import { ObjectUtils } from '@polyseme/utils/typescript/typescript-utils';
import { useTranslations } from 'next-intl';

const presentationItemMap = {
  personalized: 'brush',
  management: 'bar-chart',
  simulator: 'wand-sparkles',
} as const;

export const PresentationSection = () => {
  const t = useTranslations('landing.germen.simulator');

  return (
    <div className="flex w-full flex-col gap-4 py-16" id="presentation">
      <Typography
        as="h2"
        className="text-center text-3xl font-medium md:text-6xl"
      >
        {t('presentation.title')}
      </Typography>
      <Typography className="whitespace-pre-wrap text-center text-sm text-semantic-neutral-foreground md:text-base">
        {t('presentation.description')}
      </Typography>
      <div className="mt-6 flex flex-col gap-8 md:flex-row">
        {ObjectUtils.keys(presentationItemMap).map((key) => {
          return (
            <SimpleCard key={key} className="flex flex-1 rounded-3xl">
              <div className="flex flex-col gap-6">
                <Icon name={presentationItemMap[key]} size="md" />
                <Typography className="text-xl font-medium">
                  {t(`presentation.items.${key}`)}
                </Typography>
              </div>
            </SimpleCard>
          );
        })}
      </div>
    </div>
  );
};
